module.exports = __webpack_public_path__ + "static/assets/bafe2ce4ec50c74cb92d815281c283b6.svg";